import { useHistory, Route, useLocation } from "react-router";
import { useRecoilValueLoadable } from "recoil";

import { application } from "../atoms/application";
import ApplicationUnavailable from "../pages/ApplicationUnavailable";

// Application pages render normally until the API says the application is gone (404),
// then show the "no longer available" page instead of an empty/broken form.
const ApplicationGuard = ({ id, children }) => {
  const loadable = useRecoilValueLoadable(application(id));
  if (loadable.state === "hasValue" && loadable.contents?.notFound) {
    return <ApplicationUnavailable />;
  }
  return children;
};

export const ProtectedRoute = ({ path, Component }) => {
  let history = useHistory();
  const location = useLocation();
  const { pathname, search } = location;
  if (!localStorage.getItem("token")) {
    const redirectUrl = encodeURIComponent(pathname + search);
    history.push({
      pathname: `/login`,
      search: redirectUrl && `?redirect=${redirectUrl}`,
    });
    return null;
  }

  if (/:application(ID|Id)\b/.test(path)) {
    return (
      <Route
        key={path}
        path={path}
        exact
        render={(props) => (
          <ApplicationGuard id={props.match.params.applicationID || props.match.params.applicationId}>
            <Component {...props} />
          </ApplicationGuard>
        )}
      />
    );
  }

  return <Route key={path} component={Component} path={path} exact />;
};
